<template>
  <div v-if="$store.state.user.scope">
    <lesson-inline-grid></lesson-inline-grid>
    <div class="dashboard-patients">
      <div class="tip-details" v-if="showTips">
        <!--        <div class="text item" v-for="(item, index) in tipsList">-->
        <!--          <mu-icon value="info"/>-->
        <!--          <h2>Tip {{index + 1}} of {{tipsList.length}}: <span>{{item.tip}}</span></h2>-->
        <!--        </div>-->

        <carousel
          :paginationEnabled="false"
          :perPage="1"
          :navigationEnabled="true"
          :loop="true"
          :navigationPrevLabel="`<img src='static/dashboard/chevron-left.svg'/>`"
          :navigationNextLabel="`<img src='static/dashboard/chevron-right.svg'/>`"
        >
          <slide class="text item" v-for="(item, index) in tipsList" :key="`tip-${index}`">
            <mu-icon value="info"/>
            <h2>Tip {{ index + 1 }} of {{ tipsList.length }}: <span>{{ item.tip }}</span></h2>
          </slide>
        </carousel>
      </div>

      <div class="accordion" @click="openGettingStarted()">
        <mu-flexbox>
          <mu-flexbox-item>
            <h2>How to get started:</h2>
          </mu-flexbox-item>
          <mu-flexbox-item style="text-align: right;">
            <mu-icon :value="gettingStarted ? 'remove' : 'expand_more'"/>
          </mu-flexbox-item>
        </mu-flexbox>
      </div>

      <div class="getting-started" v-if="gettingStarted">
        <mu-row gutter>
          <mu-col width="100" tablet="50" desktop="25" v-for="(item, index) in startedData" :key="`started-data-${index}`" v-if="showStarted">
            <mu-card class="started-block" :class="item.category">
              <mu-avatar>
                <img :src="item.icon" :alt="item.title"/>
              </mu-avatar>
              <h2>{{ item.title }}</h2>
              <p>{{ item.description }}</p>
              <button class="started-cta" type="button" @click="gettingStartedPush(item)">
                {{ item.cta }}<i class="material-icons">arrow_forward</i>
              </button>
            </mu-card>
          </mu-col>
          <mu-col width="100" tablet="50" desktop="25" v-for="item in 4" :key="`dummy-started-loader-${item}`" v-if="!showStarted">
            <mu-card class="started-loader">
              <div class="dummy">
                <mu-linear-progress class="img"/>
                <mu-linear-progress class="title"/>
                <mu-linear-progress class="text"/>
                <mu-linear-progress class="btn"/>
              </div>
            </mu-card>
          </mu-col>
        </mu-row>
      </div>

      <div class="accordion" @click="openMyLessons()">
        <mu-flexbox>
          <mu-flexbox-item>
            <h2>My lessons</h2>
          </mu-flexbox-item>
          <mu-flexbox-item style="text-align: right;">
            <mu-icon :value="myLessons ? 'remove' : 'expand_more'"/>
          </mu-flexbox-item>
        </mu-flexbox>
      </div>

      <div class="lessons-block" v-if="myLessons">
        <mu-row gutter v-if="showLesson">
          <mu-col width="100" tablet="100" desktop="30">
            <div class="lessons">
              <h2>This week's lesson:</h2>
              <div class="lesson-module" :style="{ backgroundImage: 'url(' + currentLesson.image_url + ')' }"
                   @click="goToCurrentLesson()">
                <div class="lesson-text">
                  <h3>{{ currentLesson.week_name }}</h3>
                  <span>{{ currentLesson.title }}</span>
                </div>
                <div class="lesson-play">
                  <img src="static/dashboard/play-large.svg" alt="">
                </div>
              </div>
            </div>
          </mu-col>
          <mu-col width="100" tablet="100" desktop="70">
            <div class="downloads">
              <h2>This week's downloads</h2>
              <mu-row gutter>
                <mu-col class="download-module" width="100" tablet="33"
                        :style="{ backgroundImage: 'url(' + item.image_url + ')' }" desktop="33"
                        v-for="(item, index) in downloads" :key="`download-${index}`" @click.native="downloadResource(item)">
                  <div class="download-text">
                    <h3>{{ item.title }}</h3>
                  </div>
                </mu-col>
                <mu-col width="100" tablet="33" class="download-module" desktop="33" @click.native="goToDownloads()"
                        :style="{ backgroundImage: 'url(' + downloadsBg + ')' }">
                  <div class="allDownloads">
                    <div class="download-inner">
                      <mu-icon value="get_app"/>
                      <span>View all downloads</span>
                    </div>
                  </div>
                </mu-col>
              </mu-row>
            </div>
          </mu-col>
        </mu-row>
        <mu-row gutter v-if="!showLesson">
          <mu-col width="100" tablet="50" desktop="30">
            <div class="lessons">
              <h2>This week's lesson:</h2>
              <div class="lesson-module">
                <div class="dummy">
                  <mu-linear-progress class="img"/>
                </div>
              </div>
            </div>
          </mu-col>
          <mu-col width="100" tablet="50" desktop="70">
            <div class="downloads">
              <h2>This week's downloads:</h2>
              <mu-row gutter>
                <mu-col class="download-module" width="100" tablet="33" desktop="33" v-for="i in 3" :key="`download-module-dummy-${i}`">
                  <div class="dummy">
                    <mu-linear-progress class="img" :key="i"/>
                  </div>
                </mu-col>
              </mu-row>
            </div>
          </mu-col>
        </mu-row>
      </div>


      <div class="accordion" @click="openTodaysMeals()">
        <mu-flexbox>
          <mu-flexbox-item>
            <h2>Today's meals</h2>
          </mu-flexbox-item>
          <mu-flexbox-item style="text-align: right;">
            <mu-icon :value="todaysMeals ? 'remove' : 'expand_more'"/>
          </mu-flexbox-item>
        </mu-flexbox>
      </div>

      <div class="meals" v-if="todaysMeals">
        <div class="dummyLoader" v-if="recipesLoader">
          <mu-row gutter>
            <mu-col width="100" tablet="50" desktop="33">
              <div class="dummy">
                <mu-linear-progress class="img"/>
                <mu-linear-progress class="title"/>
                <mu-linear-progress class="text"/>
              </div>
            </mu-col>
            <mu-col width="100" tablet="50" desktop="33">
              <div class="dummy">
                <mu-linear-progress class="img"/>
                <mu-linear-progress class="title"/>
                <mu-linear-progress class="text"/>
              </div>
            </mu-col>
            <mu-col width="100" tablet="50" desktop="33">
              <div class="dummy">
                <mu-linear-progress class="img"/>
                <mu-linear-progress class="title"/>
                <mu-linear-progress class="text"/>
              </div>
            </mu-col>
          </mu-row>
        </div>
        <mu-row gutter v-if="!recipesLoader">
          <mu-col width="100" tablet="50" desktop="33" v-for="(item, index) in recipes" :key="`recipe-${index}`">
            <div class="recipe-card recipe-block" v-if="item.id">
              <mu-float-button v-if="index === 0 && item.id" icon="refresh" class="refresh" @click="getBreakfast()"/>
              <mu-float-button v-if="index === 1 && item.id" icon="refresh" class="refresh" @click="getLunch()"/>
              <mu-float-button v-if="index === 2 && item.id" icon="refresh" class="refresh" @click="getDinner()"/>
              <img :src="item.photoLargeUri" v-if="item.photoLargeUri" alt="" @click="goToRecipe(item.id)">
              <div class="no-image" v-else @click="goToRecipe(item.id)">
                <span>No image available</span>
              </div>
              <p v-if="index === 0">Breakfast</p>
              <p v-if="index === 1">Lunch</p>
              <p v-if="index === 2">Dinner</p>
              <h2 @click="goToRecipe(item.id)">{{ item.title }}</h2>
              <recipe-rating v-if="item.rating" :read-only="true" style="margin-bottom: 24px;"
                             :count="item.rating.ratingCount"
                             :rating="item.rating.ratingScore" :recipe="item"></recipe-rating>
            </div>
            <div class="recipe-load" v-else>
              <div class="dummy">
                <mu-linear-progress class="img"/>
                <mu-linear-progress class="title"/>
                <mu-linear-progress class="text"/>
              </div>
            </div>
          </mu-col>
          <mu-col width="100" tablet="100" desktop="100">
            <div class="recipes-banner">
              <banner-block path="/310087275/LCP_730x100" :size="[730, 100]" id="div-gpt-ad-1585223997152-0"/>
            </div>
          </mu-col>
        </mu-row>
      </div>

      <div class="accordion" @click="openPersonalised()">
        <mu-flexbox>
          <mu-flexbox-item>
            <h2>Just for you</h2>
          </mu-flexbox-item>
          <mu-flexbox-item style="text-align: right;">
            <mu-icon :value="justForYou ? 'remove' : 'expand_more'"/>
          </mu-flexbox-item>
        </mu-flexbox>
      </div>

      <div class="personalised" v-if="justForYou">
        <mu-row gutter v-if="articlesLoader">
          <mu-col width="100" tablet="50" desktop="20" v-for="(item, index) in articles" :key="`article-${index}`">
            <div class="article" @click="goToArticle(item)">
              <div class="likes">
                <mu-icon value="favorite"></mu-icon>
                <p>{{ item.post_favourites }}</p>
              </div>
              <div class="image-wrap" :style="{ backgroundImage: 'url(' + item.post_image + ')' }">
                <!--<img :src="item.post_image" alt="">-->
              </div>
              <h2>{{ item.post_title }}</h2>
            </div>
          </mu-col>
          <mu-col width="100" tablet="100" desktop="20">
            <div class="article">
              <div class="image-wrap" :style="{ backgroundImage: 'url(' + this.lifestyleBg + ')' }"
                   @click="goToLifestyle()">
                <!--<img :src="item.post_image" alt="">-->
                <div class="lifestyle">
                  <mu-icon value="local_florist"/>
                  <span>View Lifestyle</span>
                </div>
              </div>
            </div>
          </mu-col>
        </mu-row>
        <mu-row gutter v-if="!articlesLoader">
          <mu-col width="100" tablet="50" desktop="25" v-for="i in 4" :key="`articles-dummy-loader-${i}`">
            <div class="article">
              <div class="dummy">
                <mu-linear-progress class="img"/>
                <mu-linear-progress class="title"/>
              </div>
            </div>
          </mu-col>
        </mu-row>
      </div>


      <div class="accordion" @click="openCommunity()">
        <mu-flexbox>
          <mu-flexbox-item>
            <h2>Trending in the community</h2>
          </mu-flexbox-item>
          <mu-flexbox-item style="text-align: right;">
            <mu-icon :value="community ? 'remove' : 'expand_more'"/>
          </mu-flexbox-item>
        </mu-flexbox>
      </div>

      <div class="community" v-if="community">
        <mu-row gutter v-if="communityLoader">
          <mu-col width="100" tablet="100" desktop="30" class="align-motivated">
            <div class="motivated" @click="goToCommunity()">
              <img src="static/dashboard/community-general.png" alt="">
              <div class="motivated-btn">
                <mu-raised-button label="Ask our community"/>
              </div>
            </div>
          </mu-col>
          <mu-col width="100" tablet="100" desktop="70">
            <mu-row gutter class="discussion-row">
              <mu-col width="100" tablet="50" desktop="50">
                <mu-card v-for="(item, index) in discussions[0]" @click.native="goToDiscussion(item)" :key="`discussion-item-${index}`">
                  <h2 v-html="item.question"></h2>
                  <mu-list-item :title="item.display_name" disabled>
                    <mu-avatar v-if="item.profile_large" slot="left" :src="item.profile_large"/>
                    <mu-avatar v-else slot="left">{{ upperTwoInitials(item.display_name) }}</mu-avatar>
                  </mu-list-item>
                  <mu-row gutter>
                    <mu-col width="40" tablet="50" desktop="40">
                      <div class="replies">
                        <mu-icon value="reply"/>
                        <p>{{ item.replies }} replies</p>
                      </div>
                    </mu-col>
                    <mu-col width="60" tablet="50" desktop="60">
                      <div class="created">
                        <mu-icon value="access_time"/>
                        <p>{{ formatDate(item.timestamp) }}</p>
                      </div>
                    </mu-col>
                  </mu-row>
                  <img src="static/quote.svg" class="quote" alt="">
                </mu-card>
              </mu-col>
              <mu-col width="100" tablet="50" desktop="50" class="spaceArticle">
                <mu-card v-for="(item, index) in discussions[1]" @click.native="goToDiscussion(item)" :key="`discusstion-item-2-${index}`">
                  <h2>{{ item.question }}</h2>
                  <mu-list-item :title="item.display_name" disabled>
                    <mu-avatar v-if="item.profile_large" slot="left" :src="item.profile_large"/>
                    <mu-avatar v-else slot="left">{{ upperTwoInitials(item.display_name) }}</mu-avatar>
                  </mu-list-item>
                  <mu-row gutter>
                    <mu-col width="40" tablet="50" desktop="40">
                      <div class="replies">
                        <mu-icon value="reply"/>
                        <p>{{ item.replies }} replies</p>
                      </div>
                    </mu-col>
                    <mu-col width="60" tablet="50" desktop="60">
                      <div class="created">
                        <mu-icon value="access_time"/>
                        <p>{{ formatDate(item.timestamp) }}</p>
                      </div>
                    </mu-col>
                  </mu-row>
                  <img src="static/quote.svg" class="quote" alt="">
                </mu-card>
              </mu-col>
            </mu-row>
          </mu-col>
        </mu-row>
        <mu-row gutter v-if="!communityLoader" class="loader">
          <mu-col width="100" tablet="100" desktop="30" class="align-motivated">
            <div class="motivated">
              <div class="dummy">
                <mu-linear-progress class="img"/>
              </div>
            </div>
          </mu-col>
          <mu-col width="100" tablet="100" desktop="70">
            <mu-row gutter class="discussion-row">
              <mu-col width="100" tablet="50" desktop="50">
                <div class="dummy" v-for="(item, index) in 2" :key="`discussion-dummy-row-${index}`">
                  <mu-linear-progress class="card"/>
                </div>
              </mu-col>
              <mu-col width="100" tablet="50" desktop="50" class="spaceArticle">
                <div class="dummy" v-for="(item, index) in 2" :key="`discussion-dummy-row-2-${index}`">
                  <mu-linear-progress class="card"/>
                </div>
              </mu-col>
            </mu-row>
          </mu-col>
        </mu-row>
      </div>


      <div class="accordion" @click="openTrackers()" id="trackHealth">
        <mu-flexbox>
          <mu-flexbox-item>
            <h2>Track your health</h2>
          </mu-flexbox-item>
          <mu-flexbox-item style="text-align: right;">
            <mu-icon :value="trackHealth ? 'remove' : 'expand_more'"/>
          </mu-flexbox-item>
        </mu-flexbox>
      </div>

      <cards v-if="trackHealth"></cards>
      <DisplayNameModal :display="!$store.state.user.scope.accepted_display_name"></DisplayNameModal>
    </div>
  </div>
</template>
<script>
import {TweenMax, TweenLite, Power3, ScrollToPlugin} from 'gsap/all'
import 'gsap/ScrollToPlugin'

const plugins = [ScrollToPlugin];

import WeightInput from "../../../components/Tracking/Input/Weight/Weight";
import BloodGlucoseInput from "../../../components/Tracking/Input/BloodGlucose/BloodGlucose";
import UserManager from '../../../helpers/UserManager/index'
import CardOrderMixin from '../../../mixins/CardOrderMixin'
import {directive as onClickaway} from 'vue-clickaway';
import BloodPressureInput from "../../../components/Tracking/Input/BloodPressure/BloodPressure";
import SleepInput from "../../../components/Tracking/Input/Sleep/Sleep";
import InsulinInput from "../../../components/Tracking/Input/Insulin/Insulin";
import CholesterolInput from "../../../components/Tracking/Input/Cholesterol/Cholesterol";
import MoodInput from "../../../components/Tracking/Input/Mood/Mood";
import MedicationInput from "../../../components/Tracking/Input/Medication/Medication";
import NutritionInput from "../../../components/Tracking/Input/Nutrition/Nutrition.vue";
import TrackingNotifier from "../../../components/TrackingNotifier/TrackingNotifier";
import EmailVerificationPanel from "../../../components/EmailVerification/EmailVerification.vue";

import ScrollManager from "../../../helpers/ScrollManager"
import ScrollMixin from "../../../mixins/ScrollerMixin"

import "gsap"
import Alert from "../../../components/Alert/Alert";
import ActivityInput from "../../Tracking/Input/Activity/Activity";
import GdprReminder from "../../GDPRReminder/gdpr-reminder";
import MobilePhoneInput from "../../MobilePhoneInput/MobilePhoneInput";
import Cards from './Cards.vue'

import LessonsApi from '../../../api/Lessons';
import HCPMixin from "../../../mixins/HCPMixin";
import ResourcesApi from '../../../api/Resources'

import RecipeRating from "../../../views/Recipes/Components/RecipeRating.vue";
import DiscussionApi from '../../../api/Discussion'
import _ from 'lodash';
import RecipeApi from '../../../api/Recipes'
import LifeStyleApi from '../../../api/LifeStyle/index';
import category from '../../../views/Recipes/Category.vue'

import $ from 'jquery'
import Cookies from 'js-cookie'
import axios from "axios";
import config from '../../../config'
import DailyCache from '../../../helpers/DailyCache'

import BannerBlock from "../../BannerBlock/BannerBlock";
import {Carousel, Slide} from 'vue-carousel';
import DisplayNameModal from "./DisplayNameModal";
  import {sha256} from "js-sha256";

export default {
  directives: {
    onClickaway: onClickaway,
  },
  mixins: [CardOrderMixin, ScrollMixin, HCPMixin, category],
  components: {
    DisplayNameModal,
    Carousel,
    Slide,
    RecipeRating,
    Cards,
    MobilePhoneInput,
    GdprReminder,
    ActivityInput,
    Alert,
    EmailVerificationPanel,
    TrackingNotifier,
    NutritionInput,
    MedicationInput,
    MoodInput,
    CholesterolInput,
    InsulinInput,
    SleepInput,
    BloodPressureInput,
    BloodGlucoseInput,
    WeightInput,
    BannerBlock
  },
  name: 'patient-view',
  data() {
    return {
      isFabShown: true,
      settingsUpdating: false,
      fabOpen: false,
      gettingStarted: false,
      myLessons: false,
      justForYou: true,
      startedData: [],
      tipsList: null,
      list: [],
      activeLesson: 0,
      currentLesson: {},
      downloads: [],
      todaysMeals: false,
      community: false,
      trackHealth: false,
      recipes: [],
      discussions: [],
      recipesLoader: false,
      articles: [],
      articlesLoader: false,
      downloadsBg: '',
      scroller: document.getElementsByClassName('main-content')[0],
      showTips: false,
      showStarted: false,
      showLesson: false,
      lifestyleBg: '',
      communityLoader: false,
    }
  },
  created() {
    let self = this;

    self.$EventBus.$on('lc:settingsUpdated', function () {
      self.settingsUpdating = true;
      UserManager.getUserAndStore(self);
    });
    self.gettingStarted = true;
    self.myLessons = true;
    self.todaysMeals = true;
    self.justForYou = true;
    self.community = true;
    self.trackHealth = true;
  },
  watch: {
    gettingStarted: function () {
      let self = this;
      self.$nextTick(() => {
        Cookies.set('gettingStarted', self.gettingStarted);
      });
    },
    myLessons: function () {
      let self = this;
      self.$nextTick(() => {
        Cookies.set('myLessons', self.myLessons)
      });
    },
    todaysMeals: function () {
      let self = this;
      self.$nextTick(() => {
        Cookies.set('meals', self.todaysMeals)
      });
    },
    justForYou: function () {
      let self = this;
      self.$nextTick(() => {
        Cookies.set('articles', self.justForYou)
      });
    },
    community: function () {
      let self = this;
      self.$nextTick(() => {
        Cookies.set('community', self.community)
      });
    },
    trackHealth: function () {
      let self = this;
      self.$nextTick(() => {
        Cookies.set('track', self.trackHealth)
      });
    },
    fabOpen: function () {
      let self = this;
      if (self.$refs.speedDial.$el.classList.contains('md-active')) {
        self.$refs.addProgressIcon.$el._tooltip.hide();
        self.$refs.addFoodDiaryIcon.$el._tooltip.hide();
      } else {
        window.setTimeout(function () {
          self.$refs.addProgressIcon.$el._tooltip.show();
          self.$refs.addFoodDiaryIcon.$el._tooltip.show();
        }.bind(self), 300);
      }
    }
  },

  mounted() {
    let self = this;
    self.$gtag.pageview('/dashboard');
    self.scroller.addEventListener('scroll', self.checkIfFabShouldBeShown);

    if (self.fabOpen) {
      self.$refs.addProgressIcon.$el._tooltip.show();
      self.$refs.addFoodDiaryIcon.$el._tooltip.show();
    }

    self.initMounted();

    if (Cookies.get('gettingStarted')) {
      let pref = JSON.parse(Cookies.get('gettingStarted'));
      self.gettingStarted = pref;
    }

    if (Cookies.get('myLessons')) {
      let lesson = JSON.parse(Cookies.get('myLessons'));
      self.myLessons = lesson;
    }

    if (Cookies.get('meals')) {
      let meal = JSON.parse(Cookies.get('meals'));
      self.todaysMeals = meal;
    }

    if (Cookies.get('articles')) {
      let articles = JSON.parse(Cookies.get('articles'));
      self.justForYou = articles;
    }

    if (Cookies.get('community')) {
      let community = JSON.parse(Cookies.get('community'));
      self.community = community;
    }

    if (Cookies.get('track')) {
      let track = JSON.parse(Cookies.get('track'));
      self.trackHealth = track;
    }

  },
  methods: {
    gettingStartedPush(data) {
      let self = this;
      switch (data.category) {
        case 'activity':
          self.goToCurrentLesson();
          break;
        case 'blood-glucose':
        case 'progress':
          self.$router.push({
            name: 'WeightCheckin',
          });
          break;
        case 'discussion':
        case 'support':
          self.$router.push({
            name: 'QuestionsIndex',
          });
          break;
        case 'food-diary':
          self.$router.push({
            name: 'RecipeIndex',
          });
          break;
        case 'class':
          self.$router.push({
            name: "LifeStyleCategory",
            params: {
              slug: 'fitness-classes'
            }
          });
          break;
        case 'lifestyle':
          self.$router.push({
            name: "LifeStyle"
          })
          break;
        default:
          break;
      }
    },
    getBreakfast() {
      let self = this;
      self.recipes[0] = {};
      self.$forceUpdate();
      RecipeApi.search({
        page: 0,
        limit: 1,
        categories: 'breakfast',
        dietaryTypes: self.dietaryTypesList().join(','),
        shuffle: true
      })
        .then(function (response) {
          self.recipes[0] = response.data.recipes[0];
          self.$forceUpdate();
          DailyCache.set(self.recipesCacheKey(), self.recipes);
        });
    },
    getLunch() {
      let self = this;
      self.recipes[1] = {};
      self.$forceUpdate();
      RecipeApi.search({
        page: 0,
        limit: 1,
        categories: 'lunch',
        dietaryTypes: self.dietaryTypesList().join(','),
        shuffle: true
      })
        .then(function (response) {
          self.recipes[1] = response.data.recipes[0];
          self.$forceUpdate();
          DailyCache.set(self.recipesCacheKey(), self.recipes);
        });
    },
    getDinner() {
      let self = this;
      self.recipes[2] = {};
      self.$forceUpdate();
      RecipeApi.search({
        page: 0,
        limit: 1,
        categories: 'dinner',
        dietaryTypes: self.dietaryTypesList().join(','),
        shuffle: true
      })
        .then(function (response) {
          self.recipes[2] = response.data.recipes[0];
          self.$forceUpdate();
          DailyCache.set(self.recipesCacheKey(), self.recipes);
        });
    },
    upperTwoInitials(displayName) {
      if (displayName.indexOf(' ') !== -1) {
        const splitString = displayName.split(' ');
        return splitString[0].charAt(0).toUpperCase() + splitString[1].charAt(0).toUpperCase();
      }
      return displayName.charAt(0).toUpperCase();
    },
    formatDate(data) {
      let self = this;
      return moment(data).fromNow();
    },
    setInitialActiveLesson() {
      let self = this;

      self.activeLesson = self.list.filter(function (lesson) {
        return lesson.status.locked === false;
      }).length;
      self.currentLesson = self.list[self.activeLesson - 1];
    },
    clickOutsideOfSpeedDial() {
      let self = this;
      self.$refs.addProgressIcon.$el._tooltip.hide();
      self.$refs.addFoodDiaryIcon.$el._tooltip.hide();
    },
    toggle() {
      let self = this;
      self.fabOpen = !self.fabOpen;
    },
    closeFab() {

      let self = this;

      self.fabOpen = false;
    },
    checkIfFabShouldBeShown() {
      let self = this;
      if (self.scroller.clientWidth <= 600) {
        ScrollManager.isElementInViewport(self.$refs.scrollDetector) ? self.isFabShown = false : self.isFabShown = true;
      }
    },
    getScrollbarWidth() {
      return ScrollManager.getScrollbarWidth();
    },
    goTo(name) {
      this.$router.push({
        name: name
      })
    },
    openGettingStarted() {
      let self = this;
      self.gettingStarted = !self.gettingStarted;
    },
    openMyLessons() {
      let self = this;
      self.myLessons = !self.myLessons;
    },
    openTodaysMeals() {
      let self = this;
      self.todaysMeals = !self.todaysMeals;
    },
    openPersonalised() {
      let self = this;
      self.justForYou = !self.justForYou;
    },
    openCommunity() {
      let self = this;
      self.community = !self.community;
    },
    openTrackers() {
      let self = this;
      self.trackHealth = !self.trackHealth;
    },
    goToCurrentLesson() {
      let self = this;
      self.$router.push(
        {
          name: 'Lesson',
          params: {
            permalink: self.currentLesson.permalink
          }
        }
      );
    },
    downloadResource(data) {
      window.open(data.link, '_blank');
    },
    goToDownloads() {
      let self = this;
      self.$router.push({
        name: 'Downloads'
      })
    },
    goToLifestyle() {
      let self = this;
      self.$router.push({
        name: 'LifeStyle'
      })
    },
    goToArticle(data) {
      let self = this;
      self.$router.push({
        name: 'LifeStyleArticle',
        params: {
          permalink: data.post_slug
        }
      })
    },
    goToCommunity() {
      let self = this;
      self.$router.push({
        name: 'QuestionsIndex',
      })
    },
    goToDiscussion(data) {
      let self = this;
      self.$router.push({
        name: 'QuestionThread',
        params: {
          id: data.question_id
        }
      })
    },
    goToRecipe(data) {
      let self = this;
      self.$router.push({
        name: 'RecipeDetail',
        params: {
          id: data
        }
      })
    },
    getArticles() {
      let self = this;
      let cacheKey = 'dashboard:articles:' + self.$store.state.user.scope.user_id;
      // Apply on a copy: keep the lifestyle background (5th post) then trim to
      // the first four, without mutating the cached source list.
      let applyArticles = function (data) {
        let list = (data || []).slice();
        if (list[4]) self.lifestyleBg = list[4].post_image;
        self.articles = list.slice(0, 4);
        self.articlesLoader = true;
      };
      DailyCache.get(cacheKey).then(function (cached) {
        // Fresh within the day → render from cache and skip the request entirely.
        if (cached) {
          applyArticles(cached);
          return;
        }
        self.articlesLoader = false;
        LifeStyleApi.getPosts(1, 10, 'medium').then(response => {
          DailyCache.set(cacheKey, response.data);
          applyArticles(response.data);
        });
      });
    },
    recipesCacheKey() {
      return 'dashboard:recipes:' + this.$store.state.user.scope.user_id;
    },
    getRecipes() {
      let self = this;
      DailyCache.get(self.recipesCacheKey()).then(function (cached) {
        // Fresh within the day → render the cached meals and skip all three
        // recipe requests entirely.
        if (cached && cached.length) {
          self.recipes = cached.slice();
          self.recipesLoader = false;
          return;
        }
        self.recipesLoader = true;

        RecipeApi.search({
          page: 0,
          limit: 1,
          categories: 'breakfast',
          dietaryTypes: self.dietaryTypesList().join(','),
          shuffle: true
        })
          .then(function (response) {
            self.recipes.unshift(response.data.recipes[0]);
            RecipeApi.search({
              page: 0,
              limit: 1,
              categories: 'lunch',
              dietaryTypes: self.dietaryTypesList().join(','),
              shuffle: true
            })
              .then(function (response) {
                self.recipes.push(response.data.recipes[0]);
                RecipeApi.search({
                  page: 0,
                  limit: 1,
                  categories: 'dinner',
                  dietaryTypes: self.dietaryTypesList().join(','),
                  shuffle: true
                })
                  .then(function (response) {
                    self.recipesLoader = false;
                    self.recipes.push(response.data.recipes[0]);
                    DailyCache.set(self.recipesCacheKey(), self.recipes);
                  })
              })
          })
      });
    },
    getDiscussions() {
      let self = this;
      self.communityLoader = false;
      DiscussionApi.getDiscussionQuestions({
        page: 1,
        per_page: 4,
        type: "MOST_RECENT",
      })
        .then(function (response) {

          if(response === undefined) return;

          self.discussions = response.data.questions;
          self.communityLoader = true;
          let chunked = _.chunk(self.discussions, 2);
          self.discussions = chunked;
        })
    },
    getResources() {
      let self = this;
      let cacheKey = 'dashboard:resources:' + self.$store.state.user.scope.user_id;
      // Apply on a copy so the reverse/slice below never mutates the cached
      // source object.
      let applyResources = function (data) {
        self.downloads = (data || []).slice();
        self.$nextTick(function () {
          self.downloadsBg = self.downloads[0].image_url;
          self.downloads.reverse();
          self.downloads = self.downloads.slice(0, 2);
        });
        self.showLesson = true;
      };
      DailyCache.get(cacheKey).then(function (cached) {
        // Fresh within the day → render from cache and skip the request entirely.
        if (cached) {
          applyResources(cached);
          return;
        }
        ResourcesApi.getResources().then((response) => {
          DailyCache.set(cacheKey, response.data);
          applyResources(response.data);
        });
      });
    },
    getLessons() {
      let self = this;
      if (self.$store.state.lessons.length > 0) {
        self.list = self.$store.state.lessons;
        self.$nextTick(function () {
          self.setInitialActiveLesson();
          self.isLoading = false;
        });
      } else {
        self.isLoading = true;
        LessonsApi.getLessonsList()
          .then(function (response) {
            self.list = response.data;
            self.$store.state.lessons = response.data;
            self.$nextTick(function () {
              self.setInitialActiveLesson();
              self.isLoading = false;
            });
          })
      }
    },
    getTips() {
      let self = this;
      axios.get(config.apiUrl + 'tips/list')
        .then(res => {
          self.tipsList = res.data;
          self.showTips = true;
        })
        .catch(err => {
          console.error(err);
        });
    },
    getStartedData() {
      let self = this;
      let cacheKey = 'dashboard:getting-started:' + self.$store.state.user.scope.user_id;
      DailyCache.get(cacheKey).then(function (cached) {
        // Fresh within the day → render from cache and skip the request entirely.
        if (cached) {
          self.startedData = cached;
          self.showStarted = true;
          return;
        }
        axios.get(config.apiUrl + 'onboarding/getting-started')
          .then(res => {
            self.showStarted = true;
            self.startedData = res.data;
            DailyCache.set(cacheKey, res.data);
          })
          .catch(err => {
            console.error(err);
          });
      });
    },
    initMounted() {
      let self = this;
      self.getLessons();
      self.getResources();
      self.getRecipes();
      self.getArticles();
      self.getDiscussions();
      self.getTips();
      self.getStartedData();
    }
  },
}
</script>
<style lang="less">
@import url('https://fonts.googleapis.com/css?family=Poppins:700,900&display=swap');

@media (min-width: 1300px) {
  .dashboard-patients {
    width: 1200px;
    margin: 0 auto;
  }

  .mu-content-block.dashboard-patients {
    width: 1200px;
  }
}

@media (min-width: 1800px) {
  .dashboard-patients {
    width: 1500px !important;
    margin: 0 auto;
  }
}

@media (min-width: 2400px) {
  .dashboard-patients {
    width: 1800px !important;
    margin: 0 auto;
  }
}

#dashboard {
  .confirmFloat {
    position: fixed;
    bottom: 24px;
    right: 24px;
    color: white;
    background: #FF7419;
  }

  button.md-button.md-fab.md-primary.md-mini.md-clean.md-white {
    background: white !important;
  }

  button.md-button.md-fab.orange {
    background: #ff7319;
    color: white;
  }
}

.card-spacing {
  margin-bottom: 24px;
}


@media (max-width: 800px) {
  .hiddenMobileFab {
    display: none;
  }
}


#dashboardCards {
  padding: 0 20px;

  .mu-card {
    .mu-card-actions {
      .mu-flexbox {
        white-space: nowrap;
      }
    }
  }
}


.dashboard-patients {
  .tip-details {
    padding: 10px 25px;
    cursor: auto;
    border: 1px solid #0179d5;
    background-color: #e6f4ff;
    border-radius: 8px;
    -moz-border-radius: 8px;
    -webkit-border-radius: 8px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    min-height: 60px;

    .VueCarousel {
      width: 100%;

      .VueCarousel-wrapper {
        width: 90%;
      }

      .VueCarousel-navigation {
        .VueCarousel-navigation-prev {
          left: 97%;
        }

        .VueCarousel-navigation-next {
          right: 2%;
        }

        button {
          img {
            vertical-align: bottom;
          }
        }
      }

      .VueCarousel-slide {
        &.VueCarousel-slide-active {
          margin-right: 20px;
        }
      }
    }

    .text {
      display: flex;
      align-items: center;

      h2 {
        font-weight: bold;
        font-size: 1em;
        line-height: 1.4;
        margin: 0;

        span {
          font-weight: normal;
        }
      }

      i {
        color: #0179d5;
        font-size: 28px;
        margin: 0 10px 0 0;
        flex-shrink: 0;
      }
    }

    .chevrons {
      align-self: flex-end;

      i {
        color: #0179d5;
        font-size: 30px;
      }
    }

    // Keep tips readable on smaller screens: give the carousel a touch more
    // room for the nav arrows and ease off the icon/text size so nothing
    // collides or overflows the box.
    @media screen and (max-width: 600px) {
      padding-top: 12px;
      padding-bottom: 12px;

      .VueCarousel .VueCarousel-wrapper {
        width: 84%;
      }

      .VueCarousel .VueCarousel-navigation .VueCarousel-navigation-prev {
        left: 90%;
      }

      .text {
        align-items: flex-start;

        i {
          font-size: 22px;
          margin-right: 8px;
        }

        h2 {
          font-size: 0.85em;
          line-height: 1.35;
        }
      }
    }
  }

  .accordion {
    margin: 36px 0 20px;
    padding: 0 20px 14px;
    background: transparent;
    border-bottom: 1px solid #e3e9ec;
    cursor: pointer;
    transition: border-color 0.2s ease-in-out;

    .mu-flexbox {
      align-items: center;
    }

    h2 {
      margin: 0;
      color: #10283a;
      font-size: 22px;
      line-height: 1.2;
      font-weight: 700;
      letter-spacing: -0.2px;
    }

    i {
      line-height: 1.2;
      margin: 0;
      color: #8a99a3;
      font-size: 26px;
      text-align: right;
      vertical-align: middle;
      transition: color 0.2s ease-in-out;
    }

    &:hover {
      border-bottom-color: #c7d3da;

      h2,
      i {
        color: #0179d5;
      }
    }

    @media screen and (max-width: 600px) {
      margin: 24px 0 14px;
      padding-bottom: 10px;

      h2 {
        font-size: 18px;
      }

      i {
        font-size: 22px;
      }
    }
  }

  .getting-started {
    padding: 0 20px;
    transition: all 0.2s ease-in-out;
    -webkit-transition: all 0.2s ease-in-out;
    -moz-transition: all 0.2s ease-in-out;

    .started-loader {
      padding: 16px;
      border-radius: 8px;
      -moz-border-radius: 8px;
      -webkit-border-radius: 8px;
      @media screen and (max-width: 991px) {
        margin-top: 15px;
      }

      .dummy {
        .mu-linear-progress {
          background-color: #dedce2;
          margin: 15px 0;

          .mu-linear-progress-indeterminate {
            height: 9px;
            opacity: .8;
            background-color: rgba(189, 189, 189, 0.29);
          }

          &.img {
            height: 35px;
            width: 35px;
            border-radius: 60%;
          }

          &.title {
            height: 8px;
            margin-top: 25px;
          }

          &.btn {
            margin-top: 25px;
            height: 25px;
          }
        }
      }
    }

    .started-block {
      padding: 20px;
      border-radius: 12px;
      -moz-border-radius: 12px;
      -webkit-border-radius: 12px;
      border: 1px solid #e6ebee;
      box-shadow: 0 2px 8px rgba(16, 40, 58, 0.05);
      background: #fff;
      height: 100%;
      display: flex;
      flex-direction: column;
      transition: box-shadow 0.2s ease-in-out, transform 0.2s ease-in-out;
      @media screen and (max-width: 600px) {
        margin: 8px 0;
      }

      &:hover {
        box-shadow: 0 6px 18px rgba(16, 40, 58, 0.10);
        transform: translateY(-2px);
      }

      &.support, &.lifestyle {
        @media screen and (max-width: 991px) {
          margin-top: 15px;
        }
      }

      // Category accent: tint the icon chip and colour the call-to-action,
      // keeping the title/body neutral so the cards read clean and consistent.
      &.activity, &.class {
        .mu-avatar { background-color: #e9deff; }
        .started-cta { color: #5f28c9; }
      }

      &.blood-glucose, &.progress {
        .mu-avatar { background-color: #ffdad9; }
        .started-cta { color: #d83e38; }
      }

      &.discussion, &.support {
        .mu-avatar { background-color: #d9eeff; }
        .started-cta { color: #0179d5; }
      }

      &.food-diary, &.lifestyle {
        .mu-avatar { background-color: #e6ffd9; }
        .started-cta { color: #3d8517; }
      }

      h2 {
        font-weight: 700;
        font-size: 17px;
        line-height: 1.3;
        color: #10283a;
        margin: 16px 0 8px;
      }

      p {
        margin: 0 0 16px;
        font-size: 14px;
        line-height: 1.5;
        color: #5a6b75;
      }

      .started-cta {
        margin-top: auto;
        display: inline-flex;
        align-items: center;
        align-self: flex-start;
        padding: 0;
        border: none;
        background: none;
        font-family: inherit;
        font-size: 14px;
        font-weight: 600;
        letter-spacing: 0.2px;
        cursor: pointer;

        i {
          font-size: 18px;
          margin-left: 6px;
          transition: transform 0.2s ease-in-out;
        }
      }

      &:hover .started-cta i {
        transform: translateX(3px);
      }

      .mu-avatar {
        .mu-avatar-inner {
          img {
            max-width: 24px;
          }
        }
      }
    }

  }

  .lessons-block {
    padding: 0 20px;

    h2 {
      font-size: 16px;
      line-height: 1.3;
      font-weight: 600;
      color: #10283a;
      margin: 0 0 12px 0;
    }

    .row {
      .col {
        .lessons {
          .lesson-module {
            background-position: center center;
            background-size: cover;
            background-repeat: no-repeat;
            border-radius: 4px;
            -moz-border-radius: 4px;
            -webkit-border-radius: 4px;
            height: 176px;
            display: flex;
            flex-direction: column-reverse;
            cursor: pointer;
            position: relative;

            .lesson-text {
              padding: 9px 13px;
              border-radius: 0 0 4px 4px;
              -moz-border-radius: 0 0 4px 4px;
              -webkit-border-radius: 0 0 4px 4px;
              -webkit-backdrop-filter: blur(30px);
              backdrop-filter: blur(30px);
              background-color: rgba(0, 0, 0, 0.5);

              h3 {
                margin: 0;
                color: #FFF;
                font-size: 1.5em;
                line-height: 1.17;
                margin: 0 0 3px 0;
                font-weight: 500;
              }

              span {
                color: #FFF;
                font-size: 1em;
                line-height: 1.17;
              }
            }

            .dummy {
              .img {
                background-color: #dedce2;
                width: 100%;
                height: 176px;
                border-radius: 4px;
                -moz-border-radius: 4px;
                -webkit-border-radius: 4px;

                .mu-linear-progress-indeterminate {
                  background-color: rgba(189, 189, 189, 0.29);
                  height: 6px;
                  opacity: .8;
                }
              }
            }

            .lesson-play {
              position: absolute;
              left: 50%;
              top: 50%;
              transform: translate(-50%, -50%);

              img {
                height: 40px;
                display: block;
              }
            }
          }
        }

        .downloads {
          .row {
            padding-left: 22px;
            border-left: 2px solid #ddd;
            @media screen and (max-width: 991px) {
              padding-left: 0;
              border-left: none;
            }
          }

          h2 {
            padding-left: 22px;
            @media screen and (max-width: 991px) {
              padding-left: 0;
              margin-top: 20px;
              margin-bottom: 15px;
            }
          }

          .download-module {
            border-radius: 4px;
            -moz-border-radius: 4px;
            -webkit-border-radius: 4px;
            height: 176px;
            display: flex;
            flex-direction: column-reverse;
            cursor: pointer;
            background-color: #0179d5;
            background-position: center;
            //background-repeat: no-repeat;
            background-size: cover;
            background-position-y: top;
            @media screen and (max-width: 600px) {
              margin: 15px 0;
            }

            .download-text {
              padding: 15px;
              -webkit-backdrop-filter: blur(30px);
              backdrop-filter: blur(30px);
              border-radius: 0 0 4px 4px;
              -moz-border-radius: 0 0 4px 4px;
              -webkit-border-radius: 0 0 4px 4px;

              h3 {
                color: #fff;
                margin: 0;
                font-size: 16px;
              }
            }

            .dummy {
              .img {
                background-color: #dedce2;
                width: 100%;
                height: 176px;
                border-radius: 4px;
                -moz-border-radius: 4px;
                -webkit-border-radius: 4px;

                .mu-linear-progress-indeterminate {
                  background-color: rgba(189, 189, 189, 0.29);
                  height: 6px;
                  opacity: .8;
                }
              }
            }
          }

          .allDownloads {
            border-radius: 4px;
            -moz-border-radius: 4px;
            -webkit-border-radius: 4px;
            text-align: center;
            display: flex;
            flex-direction: column;
            justify-content: center;
            height: 176px;
            cursor: pointer;
            position: relative;
            -webkit-backdrop-filter: blur(30px);
            backdrop-filter: blur(30px);
            width: calc(100% + 1px);

            .download-inner {
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              width: 100%;
              height: 100%;
            }

            i {
              color: #FFF;
              font-size: 58px;

            }

            span {
              color: #FFF;
              margin: 10px 0 0;
              font-size: 20px;
              line-height: 1.2;
            }
          }
        }

        .border {
          width: 100%;
          -webkit-align-items: center;
          display: flex;
          -ms-align-items: center;
          align-items: center;
          text-align: center;
          position: relative;
        }
      }
    }
  }

  .meals {
    padding: 0 20px;

    .recipe-card {
      cursor: pointer;

      img {
        width: 100%;
        height: 208px;
        object-fit: cover;
        display: block;
        margin-bottom: 11px;
        border-radius: 4px;
        -moz-border-radius: 4px;
        -webkit-border-radius: 4px;
      }

      h2 {
        color: #0179d5;
        margin: 5px 0;
        font-size: 20px;
        font-weight: 500;
      }

      p {
        margin: 5px 0;
        text-transform: uppercase;
        font-size: 14px;
      }

      .no-image {
        height: 208px;
        width: 100%;
        background-color: rgba(0, 0, 0, 0.54);
        border-radius: 4px;
        -moz-border-radius: 4px;
        -webkit-border-radius: 4px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin-bottom: 11px;

        span {
          color: #FFF;
          font-size: 1.2em;
        }
      }
    }

    .recipe-load {
      .dummy {
        .mu-linear-progress {
          background-color: #eee;
          margin: 10px 0;
          width: 100%;
          border-radius: 6px;
          -moz-border-radius: 6px;
          -webkit-border-radius: 6px;

          &.img {
            height: 208px;
            margin: 0;
          }

          &.title {
            width: 80%;
            height: 8px;
          }

          &.text {
            height: 6px;
          }

          .mu-linear-progress-indeterminate {
            background-color: rgba(189, 189, 189, 0.29);
            height: 6px;
          }
        }
      }
    }

    .recipes-banner {
      margin: 10px 0 0;

      img {
        width: 730px;
        display: block;
        margin: 0 auto;
      }

      iframe {
        margin: 0 auto;
        display: block;
        height: 120px;
        @media screen and (max-width: 900px) {
          width: 100%;
        }
      }
    }

    .dummyLoader {
      .dummy {
        .mu-linear-progress {
          background-color: #eee;
          margin: 10px 0;
          width: 100%;
          border-radius: 6px;
          -moz-border-radius: 6px;
          -webkit-border-radius: 6px;

          &.img {
            height: 208px;
          }

          &.title {
            width: 80%;
            height: 8px;
          }

          &.text {
            height: 6px;
          }

          .mu-linear-progress-indeterminate {
            background-color: rgba(189, 189, 189, 0.29);
            height: 6px;
          }
        }
      }
    }

    .recipe-block {
      position: relative;
      height: 373px;
      @media screen and (max-width: 991px) {
        height: auto;
      }

      .refresh {
        background-color: #0179d5;
        position: absolute;
        right: 13px;
        /* Anchor to the bottom edge of the fixed-height (208px) image so the
           button stays put across breakpoints instead of chasing it with
           magic percentages. */
        top: 208px;
        transform: translateY(-50%);
        color: #FFF;
        z-index: 999;
      }
    }
  }

  .personalised {
    padding: 0 20px;

    .row {
      .col {
        .article {
          position: relative;
          cursor: pointer;
          @media screen and (max-width: 600px) {
            margin: 10px;
          }

          .image-wrap {
            overflow: hidden;
            border-radius: 4px;
            -moz-border-radius: 4px;
            -webkit-border-radius: 4px;
            width: 100%;
            height: 173px;
            background-color: #0179d5;
            background-size: cover;
            background-position: center center;
            background-repeat: no-repeat;

            img {
              width: 100%;
              height: 250px;
              transform: scale(1.3);
              transform-origin: 50% 50%;
            }

            .lifestyle {
              -webkit-backdrop-filter: blur(30px);
              backdrop-filter: blur(30px);
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              width: calc(100% + 1px);
              height: 100%;

              span {
                color: #FFF;
                margin: 10px 0 0;
                font-size: 20px;
                line-height: 1.2;
              }

              i {
                color: #FFF;
                font-size: 58px;
              }
            }
          }

          h2 {
            margin: 8px 0;
            font-size: 18px;
            padding: 0 4px;
          }

          .time {
            margin: 10px 0 0;
            display: flex;
            flex-direction: row;

            i {
              padding-right: 10px;
              color: #b6c2c7;
            }

            p {
              margin: 2px 0;
            }
          }

          .likes {
            z-index: 999;
            position: absolute;
            display: flex;
            flex-direction: row;
            top: 10px;
            right: 10px;
            padding: 5px 10px;
            background-color: #FFF;
            border-radius: 8px;
            -moz-border-radius: 8px;
            -webkit-border-radius: 8px;
            align-items: center;

            i {
              color: #d83e38;
              padding-right: 7px;
              font-size: 18px;
            }

            p {
              margin: 0;
              font-size: 14px;
              font-weight: 500;
              line-height: 17px;
            }
          }

          .dummy {
            .mu-linear-progress {
              background-color: #dedce2;
              margin: 15px 0;

              .mu-linear-progress-indeterminate {
                height: 9px;
                opacity: .8;
                background-color: rgba(189, 189, 189, 0.29);
              }

              &.img {
                height: 173px;
                border-radius: 4px;
                -moz-border-radius: 4px;
                -webkit-border-radius: 4px;
              }

              &.title {
                height: 7px;
                margin-top: 15px;
              }
            }
          }
        }
      }
    }
  }

  .community {
    padding: 0 20px;

    .row {
      .align-motivated {
        margin-top: auto;
        margin-bottom: auto;
      }
    }

    .motivated {
      cursor: pointer;

      img {
        width: 100%;
      }

      @media screen and (max-width: 600px) {
        margin-bottom: 10px;
      }

      .motivated-btn {
        margin-top: -25px;

        button {
          width: 90%;
          display: block;
          margin: 0 auto;
          background-color: #0179d5;
          color: #fff;
          font-size: 16px;
          line-height: 16px;
        }
      }
    }

    .discussion-row {
      padding-left: 23px;
      border-left: 2px solid rgba(221, 221, 221, 0.82);
      @media screen and (max-width: 991px) {
        padding-left: 0;
        border-left: none;
        margin-top: 20px;
      }
      @media screen and (max-width: 570px) {
        .spaceArticle {
          &:last-of-type {
            margin-top: 20px;
          }
        }
      }
    }

    .mu-card {
      padding: 10px;
      margin: 15px 0 0;
      position: relative;
      cursor: pointer;

      .mu-item-wrapper.disabled {
        cursor: pointer;
      }

      &:first-of-type {
        margin: 0;
      }

      .quote {
        position: absolute;
        bottom: 15px;
        right: 15px;
        width: 31px;
      }

      h2 {
        font-size: 16px;
        color: #0179d5;
        margin: 0;
      }

      .mu-item-wrapper {
        margin: 10px 0;

        .mu-item-title {
          color: #0179d5;
          font-weight: bold;
          font-size: 14px;
        }

        .mu-item-left {
          left: 0;
        }
      }

      .row {
        margin: 10px 0 0;

        .col {
          .replies, .created {
            display: flex;
            flex-direction: row;

            i {
              padding-right: 10px;
              color: #b6c2c7;
            }

            p {
              margin: 2px 0;
            }
          }
        }
      }

      .mu-item-title {
        &:before {
          content: 'Asked by ';
          color: #000;
          font-size: 14px;
          font-weight: normal;
        }
      }
    }

    .loader {
      .dummy {
        margin: 15px 0;

        .mu-linear-progress-indeterminate {
          height: 9px;
          opacity: .8;
          background-color: rgba(189, 189, 189, 0.29);
        }

        .img {
          height: 226px;
        }

        .card {
          height: 137px;
        }
      }
    }
  }

  // Single source of truth for the horizontal gutter on every dashboard
  // section + header, so they all line up to the same left/right edge instead
  // of each defining its own padding. Tune this one value to move them in/out.
  @section-gutter: 8px;

  > .tip-details,
  > .accordion,
  > .getting-started,
  > .lessons-block,
  > .meals,
  > .personalised,
  > .community {
    padding-left: @section-gutter;
    padding-right: @section-gutter;
  }
}
</style>



// WEBPACK FOOTER //
// Patient.vue?3a12c835